/** 按钮 - 工作台 - 发起流程 */
export const CONST_PERMISSION_WORKBENCH_START_PROCESS_BTN = 'startProcessBtn';
/** 按钮 - 工作台 - 管理应用 */
export const CONST_PERMISSION_WORKBENCH_MANAGER_APPLICATION_BTN = 'managerApplicationBtn';

/** 消息管理 */
export const CONST_PERMISSION_MESSAGE_ADD_MESSAGE_RECEIVER_BTN = 'addMessageReceiverBtn';
export const CONST_PERMISSION_MESSAGE_REMOVE_MESSAGE_RECEIVER_BTN = 'removeMessageReceiverBtn';
export const CONST_PERMISSION_MESSAGE_VIEW_MESSAGE_RECEIVER_BTN = 'viewMessageReceiverBtn';

/** 应用中心 */
export const CONST_PERMISSION_BUSINESS_DELETE_MODEL_RECORD_BTN = 'deleteModelRecordBtn';
export const CONST_PERMISSION_BUSINESS_MODIFIED_MODEL_RECORD_BTN = 'modifiedModelRecordBtn';
export const CONST_PERMISSION_BUSINESS_EXPORT_BUSINESS_FORM_DATA_BTN = 'exportBusinessFormDataBtn';
export const CONST_PERMISSION_BUSINESS_IMPORT_BUSINESS_FORM_DATA_BTN = 'importBusinessFormDataBtn';
export const CONST_PERMISSION_BUSINESS_SYN_PROCESS_DATA_BTN = 'synProcessDataBtn';
export const CONST_PERMISSION_BUSINESS_ADD_MODEL_RECORD_BTN = 'addModelRecordBtn';
export const CONST_PERMISSION_BUSINESS_APPLICATION_CONFIG = 'application/model-config';

/** 流程中心 -流程模板 */
export const CONST_PERMISSION_PROCESS_START_PROCESS_TEMPLATE_BTN = 'startProcessTemplateBtn';
/** 流程模板设计 */
export const CONST_PERMISSION_PROCESS_DESIGN_PROCESS_TEMPLATE_BTN = 'designProcessTemplateBtn';
export const CONST_PERMISSION_PROCESS_PUBLISH_PROCESS_TEMPLATE_BTN = 'publishProcessTemplateBtn';
export const CONST_PERMISSION_PROCESS_PREVIEW_PROCESS_TEMPLATE_BTN = 'previewProcessTemplateBtn';
export const CONST_PERMISSION_PROCESS_CONFIG_PROCESS_TEMPLATE_BTN = 'configProcessTemplateBtn';

/** 流程中心 -流程方案 */
export const CONST_PERMISSION_PROCESS_DELETE_PROCESS_SERVICE_BTN = 'deleteProcessServiceBtn';
export const CONST_PERMISSION_PROCESS_PUBLISH_PROCESS_SERVICE_BTN = 'publishProcessServiceBtn';
export const CONST_PERMISSION_PROCESS_DESIGN_PROCESSS_ERVICE_BTN = 'designProcessServiceBtn';
export const CONST_PERMISSION_PROCESS_MODIFIED_PROCESS_SERVICE_BTN = 'modifiedProcessServiceBtn';
export const CONST_PERMISSION_PROCESS_PREVIEW_PROCESS_SERVICE_BTN = 'previewProcessServiceBtn';
export const CONST_PERMISSION_PROCESS_ADD_PROCESS_SERVICE_BTN = 'addProcessServiceBtn';
export const CONST_PERMISSION_PROCESS_SET_AUTH_PROCESS_SERVICE_BTN = 'setAuthProcessServiceBtn';

/** 流程中心 -流程定义 */
export const CONST_PERMISSION_PROCESS_ENABLED_PROCESS_DEFINITION_BTN = 'enabledProcessDefinitionBtn';
export const CONST_PERMISSION_PROCESS_DELETE_PROCESS_DEFINITION_BTN = 'deleteProcessDefinitionBtn';
export const CONST_PERMISSION_PROCESS_COPY_PROCESS_DEFINITION_BTN = 'copyProcessDefinitionBtn';
export const CONST_PERMISSION_PROCESS_DESIGN_PROCESS_DEFINITION_BTN = 'designProcessDefinitionBtn';
export const CONST_PERMISSION_PROCESS_MODIFIED_PROCESS_DEFINITION_BTN = 'modifiedProcessDefinitionBtn';
export const CONST_PERMISSION_PROCESS_IMPORT_PROCESS_DEFINITION_BTN = 'importProcessDefinitionBtn';
export const CONST_PERMISSION_PROCESS_ADD_PROCESS_DEFINITION_BTN = 'addProcessDefinitionBtn';

/** 组件中心 -流水号 */
export const CONST_PERMISSION_COMPONPENTS_DELETE_SERIAL_NUMBER_INSTANCE_ID_BTN = 'deleteSerialNumberInstanceIdBtn';
export const CONST_PERMISSION_COMPONPENTS_RESET_SERIAL_NUMBER_TREE_DEFAULTVAL_BTN = 'resetSerialNumberTreeDefaultValBtn';
export const CONST_PERMISSION_COMPONPENTS_DELETE_SERIAL_NUMBER_TREE_BTN = 'deleteSerialNumberTreeBtn';
export const CONST_PERMISSION_COMPONPENTS_SAVE_NEW_SERIAL_NUMBER_TREE_BTN = 'saveNewSerialNumberTreeBtn';
export const CONST_PERMISSION_COMPONPENTS_ADD_NEW_SERIAL_NUMBER_TREE_BTN = 'addNewSerialNumberTreeBtn';

/** 组件中心 - 数据字典 */
export const CONST_PERMISSION_COMPONPENTS_SAVE_NEW_DICTIONARY_TREE_BTN = 'saveNewDictionaryTreeBtn';
export const CONST_PERMISSION_COMPONPENTS_DELETE_NEW_DICTIONARY_TREE_BTN = 'deleteNewDictionaryTreeBtn';
export const CONST_PERMISSION_COMPONPENTS_ADD_NEW_DICTIONARY_TREE_BTN = 'addNewDictionaryTreeBtn';

/** 组件中心 - 业务分类 */
export const CONST_PERMISSION_COMPONPENTS_DELETE_NEW_BUSINESS_TREE_BTN = 'deleteNewBusinessTreeBtn';
export const CONST_PERMISSION_COMPONPENTS_SAVE_NEW_BUSINESS_TREE_BTN = 'saveNewBusinessTreeBtn';
export const CONST_PERMISSION_COMPONPENTS_ADD_NEW_BUSINESS_TREE_BTN = 'addNewBusinessTreeBtn';

/** 配置中心 */
export const CONST_PERMISSION_CONFIG_CONFIG_APPLICATION_TREENODE_BTN = 'configApplicationTreeNodeBtn';
export const CONST_PERMISSION_CONFIG_DELETE_APPLICATION_TREENODE_BTN = 'deleteApplicationTreeNodeBtn';
export const CONST_PERMISSION_CONFIG_SAVE_APPLICATION_TREENODE_BTN = 'saveApplicationTreeNodeBtn';
export const CONST_PERMISSION_CONFIG_ADD_NEW_APPLICATION_TREENODE_BTN = 'addNewApplicationTreeNodeBtn';
export const CONST_PERMISSION_CONFIG_BATCH_AUTH_DATA_BTN = 'batchAuthDataBtn';

/** 文档中心 */
export const CONST_DOCUMENT_DELETE_ARCHIVE_TEMPLATE_BTN = 'deleteArchiveTemplateBtn';
export const CONST_DOCUMENT_PUBLISH_ARCHIVE_TEMPLATE_BTN = 'publishArchiveTemplateBtn';
export const CONST_DOCUMENT_DESIGN_ARCHIVE_TEMPLATE_BTN = 'designArchiveTemplateBtn';
export const CONST_DOCUMENT_MODIFIED_ARCHIVE_TEMPLATE_BTN = 'modifiedArchiveTemplateBtn';
export const CONST_DOCUMENT_COPY_ARCHIVE_TEMPLATE_BTN = 'copyArchiveTemplateBtn';
export const CONST_DOCUMENT_PREVIEW_ARCHIVE_TEMPLATE_BTN = 'previewArchiveTemplateBtn';
export const CONST_DOCUMENT_ADD_NEW_ARCHIVE_TEMPLATE_BTN = 'addNewArchiveTemplateBtn';

export const CONST_DOCUMENT_DELETE_TAG_MAPPING_FILE_BTN = 'deleteTagMappingFileBtn';
export const CONST_DOCUMENT_DOWNLOAD_TAG_FILE_BTN = 'downloadTagFileBtn';
export const CONST_DOCUMENT_DELETE_TAG_FILE_BTN = 'deleteTagFileBtn';
export const CONST_DOCUMENT_SAVE_NEW_TAG_FILE_BTN = 'saveNewTagFileBtn';
export const CONST_DOCUMENT_ADD_NEW_TAG_FILE_BTN = 'addNewTagFileBtn';

export const CONST_DOCUMENT_PREVIEW_PUBLIC_LIBRARY_FILE_BTN = 'previewPublicLibraryFileBtn';
export const CONST_DOCUMENT_DOWNLOAD_PUBLIC_LIBRARY_FILE_BTN = 'downloadPublicLibraryFileBtn';
export const CONST_DOCUMENT_SHARE_PUBLIC_LIBRARY_FIFE_BTN = 'sharePublicLibraryFileBtn';
export const CONST_DOCUMENT_DEL_PUBLIC_LIBRARY_FIFE_BTN = 'delPublicLibraryFileBtn';
export const CONST_DOCUMENT_ADD_PUBLIC_LIBRARY_FOLDER_BTN = 'addPublicLibraryFolderBtn';

export const CONST_DOCUMENT_ARCHIVE_APPROVAL_BTN = 'ArchiveApprovalBtn';
export const CONST_DOCUMENT_ARCHIVE_MODIFIED_BTN = 'ArchiveModifiedBtn';
export const CONST_DOCUMENT_ARCHIVE_DELETE_BTN = 'ArchiveDeleteBtn';

/** 系统中心 */
export const CONST_SYSTEM_BATCH_ADD_POSITION_ASSIGN_BTN = 'batchAddPositionAssignBtn';
export const CONST_SYSTEM_BATCH_DELETE_POSITION_ASSIGN_BTN = 'batchDeletePositionAssignBtn';

export const CONST_SYSTEM_BATCH_ADD_ORGANIZATION_BTN = 'batchAddOrganizationBtn';
export const CONST_SYSTEM_BATCH_DELETE_ORGANIZATION_BTN = 'batchDeleteOrganizationBtn';

export const CONST_SYSTEM_BATCH_ADD_AUTHORITY_BTN = 'batchAddAuthorityBtn';
export const CONST_SYSTEM_BATCH_DELETE_AUTHORITY_BTN = 'batchDeleteAuthorityBtn';

export const CONST_SYSTEM_BATCH_ADD_ROLE_ASSIGN_BTN = 'batchAddRoleAssignBtn';
export const CONST_SYSTEM_BATCH_DELETE_ROLE_ASSIGN_BTN = 'batchDeleteRoleAssignBtn';

export const CONST_SYSTEM_DELETE_ROLE_BTN = 'deleteRoleBtn';
export const CONST_SYSTEM_MODIFIED_ROLE_BTN = 'modifiedRoleBtn';
export const CONST_SYSTEM_ADD_ROLE_BTN = 'addRoleBtn';

export const CONST_SYSTEM_DELETE_POSITION_NODE_BTN = 'deletePositionNodeBtn';
export const CONST_SYSTEM_MODIFIED_POSITION_NODE_BTN = 'modifiedPositionNodeBtn';
export const CONST_SYSTEM_ADD_POSITION_NODE_BTN = 'addPositionNodeBtn';

export const CONST_SYSTEM_DELETE_DEPARTMENT_NODE_BTN = 'deleteDepartmentNodeBtn';
export const CONST_SYSTEM_MODIFIED_DEPARTMENT_NODE_BTN = 'modifiedDepartmentNodeBtn';
export const CONST_SYSTEM_ADD_DEPARTMENT_NODE_BTN = 'addDepartmentNodeBtn';

/** 流程中心 -流程定义 -审批流 */
export const CONST_PERMISSION_PROCESS_ADD_APPROVAL_TEMPLATE_BTN = 'addApprovalTemplateBtn';
export const CONST_PERMISSION_PROCESS_MODIFIED_APPROVAL_TEMPLATE_BTN = 'modifiedApprovalTemplateBtn';
export const CONST_PERMISSION_PROCESS_COPY_APPROVAL_TEMPLATE_BTN = 'copyApprovalTemplateBtn';
export const CONST_PERMISSION_PROCESS_PUBLISH_APPROVAL_TEMPLATE_BTN = 'publishApprovalTemplateBtn';
export const CONST_PERMISSION_PROCESS_DELETE_APPROVAL_TEMPLATE_BTN = 'deleteApprovalTemplateBtn';
export const CONST_PERMISSION_PROCESS_SET_AUTH_APPROVAL_TEMPLATE_BTN = 'setAuthApprovalTemplateBtn';

/** 流程中心 -时间管理 */
export const CONST_PERMISSION_PROCESS_ADD_TIME_CONFIG_BTN = 'addTimeConfigBtn';
export const CONST_PERMISSION_PROCESS_MODIFIED_TIME_CONFIG_BTN = 'modifiedTimeConfigBtn';
export const CONST_PERMISSION_PROCESS_DELETE_TIME_CONFIG_BTN = 'deleteTimeConfigBtn';

/** 行政中心 -打卡位置 */
export const CONST_PERMISSION_OFFICE_ADD_PUNCH_LOCATION_BTN = 'addPunchLocationBtn';
export const CONST_PERMISSION_OFFICE_MODIFIED_PUNCH_LOCATION_BTN = 'modifiedPunchLocationBtn';
export const CONST_PERMISSION_OFFICE_DELETE_PUNCH_LOCATION_BTN = 'deletePunchLocationBtn';

/** 运营中心 -项目管理分布-项目状态 */
export const CONST_OPERATION_VIEW_TIME_TREE_GANTT_BTN = 'viewTimeTreeGanttBtn';

/** 导航菜单 */
export const CONST_NAV_ROUTE_PROCESS = 'process';// 流程中心
export const CONST_NAV_ROUTE_DUCTUMENT = 'document';// 文件中心
export const CONST_NAV_ROUTE_OFFICE = 'office';// 行政中心
export const CONST_NAV_ROUTE_OPERATION = 'operation';// 运营中心
export const CONST_NAV_ROUTE_MESSAGE = 'message';// 消息中心
export const CONST_NAV_ROUTE_SYSTEM = 'system';// 系统中心
export const CONST_NAV_ROUTE_APPLICATION = 'componentsDesignTitle';// 设计中心



// WEBPACK FOOTER //
// ./src/common/constants/const-permission.js